import { useState } from "react";

import { HealthlinkDoctorDetailsForm } from "components/HealthlinkCredentialsModal/HealthlinkDoctorDetailsForm/HealthlinkDoctorDetailsForm";
import { Button } from "components/ui/Button";
import { Dialog } from "components/ui/Dialog";

export const HealthlinkDoctorDetailsModal = ({
  buttonText,
  initialValues,
  buttonVariant = "primary",
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Button variant={buttonVariant} onClick={() => setIsModalOpen(true)}>
        {buttonText || "Add credentials"}
      </Button>
      <Dialog
        title={buttonText || "Add credentials"}
        onClose={() => setIsModalOpen(false)}
        open={isModalOpen}
        width={600}
      >
        <HealthlinkDoctorDetailsForm
          initialValues={initialValues}
          closeModal={() => setIsModalOpen(false)}
        />
      </Dialog>
    </>
  );
};
